export interface DegreeInterestOption {
  type: string
  value: string
}

export interface FocusOption {
  type: string
  value: string
}

export interface SpecializationOption {
  type: string
  value: string
  focusValue: string
}

export const degreeInterestOptions: DegreeInterestOption[] = [
  { type: 'Certificate', value: '1' },
  { type: 'Associates', value: '2' },
  { type: 'Bachelors', value: '3' },
  { type: 'Masters', value: '4' },
]

export const focusOptions: FocusOption[] = [
  { type: 'Business & Finance', value: '1' },
  { type: 'Criminal Justice & Legal Services', value: '2' },
  { type: 'Psychology & Counseling', value: '3' },
  { type: 'Computers & IT', value: '4' },
  { type: 'Healthcare & Medical Assisting', value: '5' },
  { type: 'Education & Teaching', value: '6' },
  { type: 'Trade, Vocational, Career', value: '7' },
  { type: 'Liberal Arts', value: '8' },
  { type: 'General', value: '9' },
  { type: 'Nursing', value: '10' },
  { type: 'Media & Communications', value: '11' },
  { type: 'Visual Arts & Graphic Design', value: '12' },
  { type: 'Religious Studies', value: '13' },
]

export const specializationOptions: SpecializationOption[] = [
  // Business & Finance (1)
  { type: 'General Business', value: '100', focusValue: '1' },
  { type: 'Accounting', value: '101', focusValue: '1' },
  { type: 'Business Administration', value: '102', focusValue: '1' },
  { type: 'Business Analytics', value: '103', focusValue: '1' },
  { type: 'Communications', value: '104', focusValue: '1' },
  { type: 'Economics', value: '105', focusValue: '1' },
  { type: 'Finance', value: '106', focusValue: '1' },
  { type: 'Human Resources', value: '107', focusValue: '1' },
  { type: 'Management', value: '108', focusValue: '1' },
  { type: 'Digital Marketing & Advertising', value: '109', focusValue: '1' },
  { type: 'Project Management', value: '110', focusValue: '1' },
  { type: 'Sports Management', value: '111', focusValue: '1' },
  { type: 'Healthcare Administration', value: '112', focusValue: '1' },
  { type: 'Entrepreneurship', value: '113', focusValue: '1' },
  { type: 'Real Estate', value: '114', focusValue: '1' },
  { type: 'Office Management', value: '115', focusValue: '1' },
  { type: 'International Business', value: '116', focusValue: '1' },

  // Criminal Justice & Legal Services (2)
  {
    type: 'General Criminal Justice & Legal Services',
    value: '200',
    focusValue: '2',
  },
  { type: 'Corrections', value: '201', focusValue: '2' },
  { type: 'Crime Scene Investigation', value: '202', focusValue: '2' },
  { type: 'Criminal Justice', value: '203', focusValue: '2' },
  { type: 'Criminology', value: '204', focusValue: '2' },
  { type: 'Cyber Security', value: '205', focusValue: '2' },
  { type: 'Forensic Science', value: '206', focusValue: '2' },
  { type: 'Homeland Security', value: '207', focusValue: '2' },
  { type: 'Law Enforcement', value: '208', focusValue: '2' },
  { type: 'Legal & Paralegal Studies', value: '209', focusValue: '2' },
  { type: 'Public Safety Administration', value: '211', focusValue: '2' },
  { type: 'Security', value: '212', focusValue: '2' },
  { type: 'Forensic Accounting', value: '213', focusValue: '2' },
  { type: 'Fire Science', value: '214', focusValue: '2' },

  // Psychology & Counseling (3)
  { type: 'General Psychology & Counseling', value: '300', focusValue: '3' },
  { type: 'Addictions & Recovery', value: '301', focusValue: '3' },
  { type: 'Applied Psychology', value: '302', focusValue: '3' },
  { type: 'Behavioral Psychology', value: '303', focusValue: '3' },
  { type: 'Child and Adolescent Psychology', value: '304', focusValue: '3' },
  { type: 'Counseling', value: '305', focusValue: '3' },
  { type: 'Forensic Psychology', value: '307', focusValue: '3' },
  { type: 'Human Services', value: '308', focusValue: '3' },
  { type: 'Organizational Psychology', value: '310', focusValue: '3' },
  { type: 'Sociology', value: '311', focusValue: '3' },
  { type: 'Community Counselor', value: '312', focusValue: '3' },

  // Computers & IT (4)
  { type: 'General Computers & IT', value: '400', focusValue: '4' },
  { type: 'Bootcamp Programs', value: '401', focusValue: '4' },
  { type: 'Computer Programming', value: '402', focusValue: '4' },
  { type: 'Data Science & Analytics', value: '403', focusValue: '4' },
  { type: 'Game Art Development', value: '404', focusValue: '4' },
  { type: 'Information Systems', value: '405', focusValue: '4' },
  { type: 'Information Technology', value: '406', focusValue: '4' },
  { type: 'IT Project Management', value: '407', focusValue: '4' },
  { type: 'Network Security', value: '408', focusValue: '4' },
  { type: 'Product and Graphic Design', value: '409', focusValue: '4' },
  { type: 'Software Engineering', value: '410', focusValue: '4' },
  { type: 'Web Development', value: '411', focusValue: '4' },
  { type: 'CyberSecurity', value: '412', focusValue: '4' },

  // Healthcare & Medical Assisting (5)
  {
    type: 'General Healthcare & Medical Assisting',
    value: '500',
    focusValue: '5',
  },
  { type: 'Certified Nursing Assistant (CNA)', value: '501', focusValue: '5' },
  { type: 'Allied Health', value: '502', focusValue: '5' },
  { type: 'Emergency Management (EMT)', value: '503', focusValue: '5' },
  { type: 'Health Science', value: '505', focusValue: '5' },
  { type: 'Healthcare Administration', value: '506', focusValue: '5' },
  { type: 'Healthcare Management', value: '507', focusValue: '5' },
  {
    type: 'Dental, Medical, or Pharmacy Technician',
    value: '508',
    focusValue: '5',
  },
  { type: 'Medical Billing & Coding', value: '509', focusValue: '5' },
  { type: 'Medical Office Assistant', value: '510', focusValue: '5' },
  {
    type: 'Nutrition, Fitness, and Sports Science',
    value: '511',
    focusValue: '5',
  },
  { type: 'Public Health', value: '512', focusValue: '5' },

  // Education & Teaching (6)
  { type: 'General Education & Teaching', value: '600', focusValue: '6' },
  { type: 'Adult Education/Learning', value: '601', focusValue: '6' },
  { type: 'Early Childhood Development', value: '602', focusValue: '6' },
  { type: 'Educational Administration', value: '603', focusValue: '6' },
  { type: 'K-12 Education', value: '604', focusValue: '6' },
  { type: 'Social Studies', value: '605', focusValue: '6' },
  { type: 'Special Education', value: '606', focusValue: '6' },
  { type: 'Teacher Licensure', value: '607', focusValue: '6' },

  // Trade, Vocational, Career (7)
  { type: 'General Trade, Vocational, Career', value: '700', focusValue: '7' },
  { type: 'Automotive Focused', value: '701', focusValue: '7' },
  { type: 'Aviation Focused', value: '702', focusValue: '7' },
  { type: 'Certified Nursing Assistant (CNA)', value: '703', focusValue: '7' },
  { type: 'Construction Management', value: '704', focusValue: '7' },
  { type: 'Electrical Technician', value: '705', focusValue: '7' },
  { type: 'Fire Science', value: '706', focusValue: '7' },
  { type: 'Truck Driver (CDL)', value: '707', focusValue: '7' },
  { type: 'HVAC', value: '708', focusValue: '7' },
  { type: 'Welding', value: '709', focusValue: '7' },
  { type: 'Vet Tech', value: '710', focusValue: '7' },
  { type: 'Pharmacy Tech', value: '711', focusValue: '7' },
  { type: 'Massage Therapy', value: '712', focusValue: '7' },
  { type: 'Culinary', value: '713', focusValue: '7' },

  // Liberal Arts (8)
  { type: 'General Liberal Arts', value: '800', focusValue: '8' },
  { type: 'Creative Writing & English', value: '801', focusValue: '8' },
  { type: 'Communications', value: '802', focusValue: '8' },
  { type: 'History', value: '803', focusValue: '8' },
  { type: 'Religious Studies', value: '804', focusValue: '8' },
  { type: 'Sociology', value: '805', focusValue: '8' },
  { type: 'Humanities', value: '806', focusValue: '8' },
  { type: 'Political Science', value: '807', focusValue: '8' },
  { type: 'Math Science and Engineering', value: '808', focusValue: '8' },

  // General (9)
  { type: 'General/Undecided', value: '900', focusValue: '9' },

  // Nursing (10)
  { type: 'All Nursing Programs (General)', value: '1000', focusValue: '10' },
  { type: 'Entry Level', value: '1001', focusValue: '10' },
  { type: 'RN Degree Programs', value: '1002', focusValue: '10' },
  { type: 'RN to BSN Bridge Programs', value: '1003', focusValue: '10' },
  { type: 'MSN Programs', value: '1004', focusValue: '10' },

  // Media & Communications (11)
  {
    type: 'All Media & Communications Programs (General)',
    value: '1100',
    focusValue: '11',
  },
  { type: 'Social Media Management', value: '1101', focusValue: '11' },
  { type: 'Animation & Video Graphics', value: '1102', focusValue: '11' },
  { type: 'Commercial & Advertising Art', value: '1103', focusValue: '11' },
  { type: 'Computer Media Applications', value: '1104', focusValue: '11' },
  { type: 'Design & Visual Communications', value: '1105', focusValue: '11' },
  { type: 'Film/Video & Cinematography', value: '1106', focusValue: '11' },
  { type: 'Graphic Design', value: '1107', focusValue: '11' },
  { type: 'Intermedia/Multimedia', value: '1108', focusValue: '11' },
  { type: 'Photography', value: '1109', focusValue: '11' },
  { type: 'Recording Arts Technology', value: '1110', focusValue: '11' },
  { type: 'Web Design', value: '1111', focusValue: '11' },

  // Visual Arts & Graphic Design (12)
  {
    type: 'All Visual Arts & Graphic Design Programs (General)',
    value: '1200',
    focusValue: '12',
  },
  { type: 'Design & Visual Communications', value: '1201', focusValue: '12' },
  { type: 'Graphic Design', value: '1202', focusValue: '12' },
  { type: 'Industrial Design', value: '1203', focusValue: '12' },
  { type: 'Interior Design', value: '1204', focusValue: '12' },
  { type: 'Photography', value: '1205', focusValue: '12' },
  { type: 'Visual Arts', value: '1206', focusValue: '12' },

  // Religious Studies (13)
  {
    type: 'All Religious Studies Programs (General)',
    value: '1300',
    focusValue: '13',
  },
  { type: 'Christian Studies', value: '1301', focusValue: '13' },
  { type: 'Ministry', value: '1302', focusValue: '13' },
  { type: 'Religious Studies', value: '1303', focusValue: '13' },
  { type: 'Theology', value: '1304', focusValue: '13' },
  { type: 'Pastoral Counseling', value: '1305', focusValue: '13' },
]

export function getSpecializationsForFocus(
  focusValue: string,
): SpecializationOption[] {
  return specializationOptions.filter((s) => s.focusValue === focusValue)
}

export const educationLevels = [
  'High School Diploma / GED',
  'Some College, No Degree',
  "Associate's Degree",
  "Bachelor's Degree",
  "Master's Degree or Higher",
]

// Maps educationLevels display text to API highestEducation values
export const educationLevelApiValues: Record<string, string> = {
  'High School Diploma / GED': '1',
  'Some College, No Degree': '2',
  "Associate's Degree": '3',
  "Bachelor's Degree": '4',
  "Master's Degree or Higher": '5',
}

// Keep DegreeCategory for the category grid / listing pages
export interface DegreeCategory {
  id: string
  name: string
  icon: string
  description: string
  programCount: number
  focusValue: string // maps to focusOptions value
}

export const degreeCategories: DegreeCategory[] = [
  {
    id: 'business',
    name: 'Business & Finance',
    icon: 'BriefcaseIcon',
    description:
      'Develop leadership skills and business acumen for the modern corporate world.',
    programCount: 1245,
    focusValue: '1',
  },
  {
    id: 'criminal-justice',
    name: 'Criminal Justice & Legal Services',
    icon: 'ShieldCheckIcon',
    description:
      'Protect and serve with degrees in law enforcement, criminology, and legal studies.',
    programCount: 640,
    focusValue: '2',
  },
  {
    id: 'psychology',
    name: 'Psychology & Counseling',
    icon: 'BrainIcon',
    description:
      'Understand human behavior and help others through counseling and therapy.',
    programCount: 785,
    focusValue: '3',
  },
  {
    id: 'computer-science',
    name: 'Computers & IT',
    icon: 'MonitorIcon',
    description:
      'Master programming, cybersecurity, and data analytics in a fast-growing field.',
    programCount: 892,
    focusValue: '4',
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Medical Assisting',
    icon: 'HeartPulseIcon',
    description:
      'Prepare for a rewarding career in health administration or public health.',
    programCount: 1530,
    focusValue: '5',
  },
  {
    id: 'education',
    name: 'Education & Teaching',
    icon: 'BookOpenIcon',
    description:
      'Shape the future by becoming a certified teacher or educational administrator.',
    programCount: 920,
    focusValue: '6',
  },
  {
    id: 'trade-vocational',
    name: 'Trade, Vocational, Career',
    icon: 'WrenchIcon',
    description:
      'Get hands-on training for skilled trades and vocational careers.',
    programCount: 750,
    focusValue: '7',
  },
  {
    id: 'liberal-arts',
    name: 'Liberal Arts',
    icon: 'LibraryIcon',
    description:
      'Develop critical thinking and communication skills applicable to any career.',
    programCount: 1105,
    focusValue: '8',
  },
  {
    id: 'nursing',
    name: 'Nursing',
    icon: 'HeartPulseIcon',
    description:
      'Advance your nursing career with BSN, MSN, and specialized nursing programs.',
    programCount: 680,
    focusValue: '10',
  },
  {
    id: 'media-communications',
    name: 'Media & Communications',
    icon: 'RadioIcon',
    description:
      'Build skills in digital media, journalism, and communications.',
    programCount: 520,
    focusValue: '11',
  },
]
